/**
 *
 * PrivacyPolicyPage
 *
 */
import { Box, Button, Typography } from '@mui/joy';
import * as React from 'react';
import styled from 'styled-components/macro';
import { PRIVACY_POLICY_ROUTE } from 'app/constants/route';

interface Props { }

export function PrivacyPolicyPage(props: Props) {
  return (
    <Box
      sx={{
        // height: '100vh',
        scrollSnapType: 'y mandatory',
        '& > div': {
          scrollSnapAlign: 'start',
        },
      }}
    >
      <PrivacyPolicy></PrivacyPolicy>
    </Box>
  );
}

const Div = styled.div``;

const PrivacyPolicy = () => {
  return (
    <Box sx={{ my: 4, mb: 6, mx: 6 }}>
      <Typography level="title-lg" mb={2} textAlign={'center'}>
        PRIVACY POLICY
      </Typography>

      <ol>
        <li>
          <Typography level="body-md">INTRODUCTION</Typography>
          <Typography level="body-sm">
            AcademIX Ltd. ("we", "us", or "our") respects your privacy and is
            committed to protecting it through our compliance with this privacy
            policy (the "Policy"). This Policy describes how we collect, use,
            disclose, and protect personal information in connection with our
            math exercise generation service (the "Service").
          </Typography>
        </li>
        <Box sx={{ m: 2 }}></Box>
        <li>
          <Typography level="body-md">
            COLLECTION OF PERSONAL INFORMATION
          </Typography>
          <Typography level="body-sm">
            We may collect the following types of personal information: <br />
            Contact Information: name, email address, phone number, and other
            contact details <br />
            User-Generated Data: data you input into the Service, such as
            academic goals, student performance, or other relevant information
            <br />
            Technical Information: IP addresses, browser types, operating
            systems, and other technical information about your device
          </Typography>
        </li>

        <Box sx={{ m: 2 }}></Box>
        <li>
          <Typography level="body-md">USE OF PERSONAL INFORMATION</Typography>
          <Typography level="body-sm">
            We use personal information to: <br />
            Provide and improve the Service <br />
            Respond to inquiries and support requests <br />
            Communicate with you about our services and updates <br />
            Analyze usage patterns and preferences to enhance the user
            experience <br />
            Comply with legal obligations and protect our rights
          </Typography>
        </li>

        <Box sx={{ m: 2 }}></Box>
        <li>
          <Typography level="body-md">
            DISCLOSURE OF PERSONAL INFORMATION
          </Typography>
          <Typography level="body-sm">
            We may disclose personal information:
            <br />
            To service providers who assist us in operating the Service <br />
            To comply with legal obligations or respond to lawful requests from
            authorities <br />
            In connection with a merger, acquisition, or sale of AcademIX Ltd.
          </Typography>
        </li>

        <Box sx={{ m: 2 }}></Box>
        <li>
          <Typography level="body-md">
            PROTECTION OF PERSONAL INFORMATION
          </Typography>
          <Typography level="body-sm">
            We implement reasonable security measures to protect personal
            information from unauthorized access, disclosure, or destruction.
          </Typography>
        </li>

        <Box sx={{ m: 2 }}></Box>
        <li>
          <Typography level="body-md">CHANGES TO THIS POLICY</Typography>
          <Typography level="body-sm">
            We may update this Policy at any time without notice. Continued use
            of the Tool constitutes acceptance of such updates.
          </Typography>
        </li>
        <Box sx={{ m: 2 }}></Box>
        <li>
          <Typography level="body-md">EFFECTIVE DATE</Typography>
          <Typography level="body-sm">
            This Policy is effective as of July 15th, 2024 and supersedes all
            prior versions.
          </Typography>
        </li>
      </ol>

      <Typography level="body-md" mt={2}>
        By using the Service, you acknowledge that you have read, understood,
        and agreed to be bound by this Policy.
      </Typography>
    </Box>
  );
};
